import { View } from "react-native"
import { theme } from "@common/theme/theme"
import { ActivityIndicator } from "react-native-paper"
import TextM from "@common/components/text/TextM"
import React from "react"
import TextButtonM from "@common/components/button/TextButtonM"
import Animated, { FadeIn, FadeOut } from "react-native-reanimated"

/**
 * `onRetry` n'est passé que lorsque la connexion est réellement à l'arrêt
 * depuis un moment — pas pendant une connexion initiale normale. Sans lui, cet
 * écran n'offrait qu'« Annuler », qui fait *quitter* le live : quand la reprise
 * n'aboutissait pas, il n'existait aucun moyen de rester et de retenter.
 *
 * Les deux boutons s'excluent : tant que la connexion suit son cours normal on
 * ne propose qu'« Annuler » ; dès qu'elle est bloquée, on ne propose que
 * « Réessayer ». Empiler les deux au moment où l'utilisateur est le plus perdu
 * l'invite à choisir celui qui le fait sortir de la séance.
 */
export const ConnectingView = ({ width, height, onPress, onRetry, isRetrying, miniMode, text = "Connexion en cours..." }) => <Animated.View
    entering={FadeIn.duration(300)}
    exiting={FadeOut.duration(300)}
    style={{
        flex: 1,
        position: "absolute",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 20,
        width: width,
        height: height,
        backgroundColor: theme.colors.transparent
    }}><View style={{
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    width: width,
    height: height,
    backgroundColor: theme.colors.transparent
}}>
    <View style={{flex: 1,
        width: width,
        height: height,
        backgroundColor: theme.colors.black,
        opacity: 0.5, position:
            "absolute"}} />
    <ActivityIndicator color={theme.colors.white} size={"large"} />
    <TextM color={theme.colors.white} style={{ marginTop: 6 }}>{text}</TextM>
    {!miniMode && !!onRetry && <TextButtonM
        onPress={onRetry}
        loading={isRetrying}
        trackingId="retry_connecting"
        style={{
            marginTop: 20,
        }}
        color={theme.colors.white}
        fontWeight="ExtraBold"
        label="Réessayer" />}
    {!miniMode && !onRetry && <TextButtonM
        onPress={onPress}
        trackingId="cancel_connecting"
        style={{
            marginTop: 20,
        }}
        color={theme.colors.white}
        fontWeight="ExtraBold"
        label="Annuler" />}
</View>
</Animated.View>